import { Navigate, Route, Routes as Switch } from 'react-router-dom';

import ContactLandingPage from '../../pages/common/LandingPage/Pages/Contact';
import ServicesLandingPage from '../../pages/common/LandingPage/Pages/Services';
import RegisterLandingPage from '../../pages/common/LandingPage/Pages/Register';
import { LandingPage } from '../../pages/common/LandingPage/Pages';
import About from '../../pages/common/LandingPage/Pages/AboutUs';
import { Version } from '../../version';
import { Test } from '../../pages/common/Test';
import { BudgetReport } from '../../utils/pdf/Budget';
import { ChecklistReport } from '../../utils/pdf/ChecklistReport';
import { ChecklistPublicReport } from '../../pages/common/ChecklistReport/public';

// PARA NÃO CAIR NA REVALIDAÇÃO DO USEAUTH
export const WHITELIST = [
  '/',
  // '/page-login',
  '/budget-report',
  '/checklist-report',
  '/page-services',
  '/page-aboutUs',
  '/page-contact',
  '/checklist-view-report',
];

export const PublicRoutes = () => {
  return (
    <Switch>
      <Route path="/" element={<LandingPage />} />
      <Route path="/test" element={<Test />} />
      <Route path="/version" element={<Version />} />|
      <Route path="/landing-page" element={<Navigate to="/" />} />
      <Route path="/page-services" element={<ServicesLandingPage />} />
      <Route path="/page-contact" element={<ContactLandingPage />} />
      <Route path="/page-register" element={<RegisterLandingPage />} />
      <Route path="/page-aboutUs" element={<About />} />
      <Route path="/budget-report" element={<BudgetReport />} />
      <Route path="/budgets" element={<BudgetReport />} />
      <Route path="/checklist-report" element={<ChecklistReport />} />
      <Route
        path="/checklist-view-report"
        element={<ChecklistPublicReport />}
      />
    </Switch>
  );
};
